import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";
import { Globals } from "../../../globals";
import { Router } from "@angular/router";
import { SwiperComponent, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface, SwiperCoverflowEffectInterface } from "ngx-swiper-wrapper";
import { OnBoardingStepService } from "./onBoarding.service";
import { OnBoardingStepDetail, OnBoardingAllergy, OnBoardingAdditive, OnBoardingPreference } from "../../shared/models/onBoarding.model";
import { KeyValueBase } from "../../shared/models/interface";
import { CoreCOMService } from "../../services/com.service";
import { CommonService } from "../../services/common.service";
import { IOSHelperService } from "../../services/IOSHelper.service";

@Component({
  selector: "onborarding",
  templateUrl: "./onborarding.component.html",
  styleUrls: ["./onborarding.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class OnborardingComponent implements OnInit, AfterViewInit, OnDestroy {
  public show = true;
  public selectedAllergyItems: string;
  @ViewChild("onBoardingGreeting", { read: TemplateRef }) onBoardingGreetingTemplate: TemplateRef<any>;
  @ViewChild("onBoardingPostalCode", { read: TemplateRef }) onBoardingPostalCodeTemplate: TemplateRef<any>;
  @ViewChild("onBoardingGender", { read: TemplateRef }) onBoardingGenderTemplate: TemplateRef<any>;
  @ViewChild("onBoardingBirthdate", { read: TemplateRef }) onBoardingBirthdateTemplate: TemplateRef<any>;
  @ViewChild("onBoardingAllergy", { read: TemplateRef }) onBoardingAllergyTemplate: TemplateRef<any>;
  @ViewChild("onBoardingPreference", { read: TemplateRef }) onBoardingPreferenceTemplate: TemplateRef<any>;
  @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
  @ViewChild("group", { read: ElementRef }) allergyItems: ElementRef;
  @ViewChild("postalcode") postalCodeEle: ElementRef;
  @ViewChild("firstName") firstNameEle: ElementRef;

  public onBoardingStepTemplateList: TemplateRef<any>[] = new Array();
  public type = "component";
  public genders: KeyValueBase[];
  public selectedGenderValue: number;
  public allergies: OnBoardingAllergy[];
  public additives: OnBoardingAdditive[];
  public preferences: OnBoardingPreference[];
  public onBoardingStepDetail: OnBoardingStepDetail;

  public disabled = false;

  private coverFlowSetting: SwiperCoverflowEffectInterface = {
    rotate: 50,
    stretch: 20,
    depth: 10,
    modifier: 1,
    slideShadows: true
  };

  private scrollbar: SwiperScrollbarInterface = {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true
  };

  private pagination: SwiperPaginationInterface = {
    el: ".swiper-pagination",
    clickable: false,
    hideOnClick: true
  };

  public config: SwiperConfigInterface = {
    init: false,
    a11y: true,
    direction: "horizontal",
    slidesPerView: 1,
    keyboard: false,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: true,
    loop: false,
    effect: "coverflow",
    coverflowEffect: this.coverFlowSetting
  };

  constructor(private globalVariable: Globals, private router: Router, private onBoardingStepService: OnBoardingStepService
    , private changeDetectorRef: ChangeDetectorRef, private commonSrvice: CommonService, private _coreCOMService: CoreCOMService, private _iosHelperService: IOSHelperService) { }

  ngOnInit() {
    this.onBoardingStepService.GetOnBoardingDetail().then((data) => {
      this.onBoardingStepDetail = data;
      this.fillOnboardingTemplateList();
      this.config.init = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    // Cleanup just before Angular destroys the directive/component. Unsubscribe Observables and detach event handlers to avoid memory leaks.
    // Called just before Angular destroys the directive/component.
  }

  public setLoginResolver() {
    this.globalVariable.isOnBoardingActive = false;
    this.router.navigateByUrl("/login");
  }

  public navigateToHome() {
    this.router.navigateByUrl("/");
  }

  public toggleType(): void {
    this.type = (this.type === "component") ? "directive" : "component";
  }

  public toggleDisabled(): void {
    this.disabled = !this.disabled;
  }

  public toggleDirection(): void {
    this.config.direction = (this.config.direction === "horizontal") ? "vertical" : "horizontal";
  }

  public toggleSlidesPerView(): void {
    if (this.config.slidesPerView !== 1) {
      this.config.slidesPerView = 1;
    } else {
      this.config.slidesPerView = 2;
    }
  }

  public toggleOverlayControls(): void {
    if (this.config.navigation) {
      this.config.scrollbar = false;
      this.config.navigation = false;

      this.config.pagination = this.pagination;
    } else if (this.config.pagination) {
      this.config.navigation = false;
      this.config.pagination = false;

      this.config.scrollbar = this.scrollbar;
    } else {
      this.config.scrollbar = false;
      this.config.pagination = false;

      this.config.navigation = true;
    }
  }

  public logAllergyItem() {
    console.log(this.selectedAllergyItems);
    console.log(this.selectedGenderValue);
  }

  public hideKeyboardOnEnter(ele) {
    (ele as HTMLElement).blur();
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public test() { console.log(this.allergies); }

  public fillOnboardingTemplateList(): TemplateRef<any>[] {
    for (const step of this.onBoardingStepDetail.templateNames) {
      switch (step) {
        case "onBoardingGreeting": {
          this.onBoardingStepTemplateList.push(this.onBoardingGreetingTemplate);
          break;
        }
        case "onBoardingPostalCode": {
          this.onBoardingStepTemplateList.push(this.onBoardingPostalCodeTemplate);
          break;
        }
        case "onBoardingBirthdate": {
          this.onBoardingStepTemplateList.push(this.onBoardingBirthdateTemplate);
          break;
        }
        case "onBoardingGender": {
          this.genders = this.onBoardingStepDetail.StepDetailGender.genders;
          this.onBoardingStepTemplateList.push(this.onBoardingGenderTemplate);
          break;
        }
        case "onBoardingAllergy": {
          this.allergies = this.onBoardingStepDetail.StepDetailAllergy.alergies;
          this.additives = this.onBoardingStepDetail.StepDetailAllergy.additives;
          this.onBoardingStepTemplateList.push(this.onBoardingAllergyTemplate);
          break;
        }
        case "onBoardingPreference": {
          this.preferences = this.onBoardingStepDetail.StepDetailPrefences.preferences;
          this.onBoardingStepTemplateList.push(this.onBoardingPreferenceTemplate);
          break;
        }
        default: {
          break;
        }
      }
    }
    return this.onBoardingStepTemplateList;
  }
}
